<template>
  <v-card class="ma-1">
    <v-layout>
      <v-flex xs12>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12 lg12 class="pb-0">
              <v-card-text>
                {{expense.tripDate|moment('DD MMM YYYY')}} |<b> {{expense.category.name}}</b>
                  <v-chip label v-if="expense.haveInvoice" small color="green"
                          text-color="white" disabled>have invoice</v-chip><br />
                <span v-if="typeof expense.systemInfo !== 'undefined' && expense.systemInfo !== ''">
                  {{expense.systemInfo}}
                </span>
                <span v-else>{{expense.remark}}</span> |
                <b>{{expense.subTotal | numformat('Rp. ', 0)}}</b>
              </v-card-text>
            </v-flex>
            <v-flex xs12 lg12 class="ma-0 pa-0">
              <v-layout row wrap>
                <v-flex xs6 lg6>
                  <v-btn flat block @click.native="edit">
                    <v-icon>edit</v-icon>
                    {{editable ? 'Edit' : 'View'}}
                  </v-btn>
                </v-flex>
                <v-flex xs6 lg6>
                  <v-btn flat block @click.native="_delete" :disabled="disableDelete">
                    <v-icon>delete</v-icon>
                    &nbsp;Delete
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  name: 'ExpenseCard',
  props: {
    value: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      expense: this.value
    }
  },
  computed: {
    disableDelete () {
      return !this.editable || !this.expense.deleteable
    }
  },
  methods: {
    _delete () {
      this.$emit('delete', this.expense)
    },
    edit () {
      this.$emit('edit', this.expense)
    }
  }
}
</script>

<style scoped>
  .linkitem:hover {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/business-trip/ExpenseCard.vue